/*
 * Horizon product-card hover videos
 *
 * Uses delegated events so it also works for product recommendation
 * cards inserted after the initial page load.
 */

(() => {
  if (window.__horizonExternalHoverVideoInstalled) return;
  window.__horizonExternalHoverVideoInstalled = true;

  const desktopHoverQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (min-width: 750px)'
  );

  function getGallery(eventTarget) {
    if (!(eventTarget instanceof Element)) return null;

    return eventTarget.closest('.card-gallery');
  }

  function getHoverVideo(gallery) {
    if (!(gallery instanceof HTMLElement)) return null;

    const slides = gallery.querySelectorAll('slideshow-slide');

    if (slides.length < 2) return null;

    return slides[1].querySelector(
      'video.card-gallery__hover-video'
    );
  }

  async function playHoverVideo(gallery) {
    if (!desktopHoverQuery.matches) return;

    const video = getHoverVideo(gallery);
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    try {
      await video.play();
    } catch (error) {
      console.warn(
        'Product-card hover video could not play:',
        error
      );
    }
  }

  function resetHoverVideo(gallery) {
    const video = getHoverVideo(gallery);
    if (!video) return;

    video.pause();

    try {
      video.currentTime = 0;
    } catch {
      /*
       * Seeking can fail briefly when metadata has not finished loading.
       */
    }
  }

  document.addEventListener('pointerover', event => {
    if (!desktopHoverQuery.matches) return;

    const gallery = getGallery(event.target);
    if (!gallery) return;

    /*
     * Ignore pointer movement between elements inside the same gallery.
     */
    if (
      event.relatedTarget instanceof Node &&
      gallery.contains(event.relatedTarget)
    ) {
      return;
    }

    /*
     * Horizon switches to the second slide on pointer entry.
     * Wait two frames so the video slide is visible before playing.
     */
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        playHoverVideo(gallery);
      });
    });
  });

  document.addEventListener('pointerout', event => {
    const gallery = getGallery(event.target);
    if (!gallery) return;

    /*
     * Ignore pointer movement between elements inside the same gallery.
     */
    if (
      event.relatedTarget instanceof Node &&
      gallery.contains(event.relatedTarget)
    ) {
      return;
    }

    resetHoverVideo(gallery);
  });

  document.addEventListener('focusin', event => {
    const gallery = getGallery(event.target);
    if (!gallery) return;

    playHoverVideo(gallery);
  });

  document.addEventListener('focusout', event => {
    const gallery = getGallery(event.target);
    if (!gallery) return;

    if (
      event.relatedTarget instanceof Node &&
      gallery.contains(event.relatedTarget)
    ) {
      return;
    }

    resetHoverVideo(gallery);
  });

  desktopHoverQuery.addEventListener('change', event => {
    if (event.matches) return;

    document
      .querySelectorAll(
        '.card-gallery video.card-gallery__hover-video'
      )
      .forEach(video => {
        video.pause();

        try {
          video.currentTime = 0;
        } catch {
          // Metadata may not be ready.
        }
      });
  });
})();